import { Alert, AlertProps, styled } from '@mui/material'
import { AnyError } from '@src/types/error'
import { forwardRef } from 'react'
import { useErrorMessage } from './Error-hooks'

interface ErrorAlertProps extends Omit<AlertProps, 'severity'> {
  error?: AnyError
  gutterBottom?: boolean
}

const StyledErrorAlert = styled(Alert)<{ gutterBottom: boolean }>(({ gutterBottom, theme }) => ({
  marginBottom: gutterBottom ? theme.spacing(1) : undefined,
}))

const ErrorAlert = forwardRef<HTMLDivElement, ErrorAlertProps>(
  ({ children, error, gutterBottom = false, ...props }, ref) => {
    const errorMessage = useErrorMessage(error)
    return (
      <StyledErrorAlert ref={ref} gutterBottom={gutterBottom} severity="error" {...props}>
        {children ?? errorMessage}
      </StyledErrorAlert>
    )
  },
)

ErrorAlert.displayName = 'ErrorAlert'

export default ErrorAlert
